import { useHotkeys } from 'react-hotkeys-hook';
import { useFeatureFlag } from './useFeatureFlag';
import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';

export const useCtrlEnterHotkey = (callback: () => void, isEnabled = true) => {
  const areHotkeysEnabled = useFeatureFlag(FEATURE_FLAGS.ENABLE_HOTKEYS);
  useHotkeys('ctrl+enter, meta+enter', callback, {
    enableOnFormTags: ['input', 'select', 'textarea'],
    enabled: areHotkeysEnabled && isEnabled
  });
};
